const getAllContractsForClaim = () => {
  const contractAddresses = process.env.REACT_APP_VESTING_CONFIG
  return contractAddresses ? JSON.parse(contractAddresses) : {}
}

export { getAllContractsForClaim }
